var React = require('react');

function InStok (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","key":0}),React.createElement("path",{"d":"M7.5 15.5l6 5 9-11","stroke":"#fff","strokeWidth":"2","key":1})]);
}

InStok.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = InStok;

InStok.default = InStok;
